import { ButtonProps as MuiButtonProps, Skeleton } from '@mui/material';
export interface ButtonSkeletonProps extends Pick<MuiButtonProps, 'size' | 'fullWidth' | 'className'> {
  circular?: boolean;
  width?: string | number;
  height?: string | number;
}

const getWidth = ({ size, fullWidth, width }: Pick<ButtonSkeletonProps, 'size' | 'fullWidth' | 'width'>) => {
  if (fullWidth) return '100%';

  if (width) return width;

  switch (size) {
    case 'xLarge':
      return 56;
    case 'large':
      return 48;
    case 'small':
      return 32;
    case 'xSmall':
      return 28;
    default:
      return 40;
  }
};

const getHeight = ({ size, height }: Pick<ButtonSkeletonProps, 'size' | 'height'>) => {
  if (height) return height;

  switch (size) {
    case 'xLarge':
      return 56;
    case 'large':
      return 48;
    case 'small':
      return 32;
    case 'xSmall':
      return 28;
    default:
      return 40;
  }
};

const ButtonSkeleton = ({
  size = 'medium',
  circular,
  fullWidth,
  width,
  height,
  className,
}: ButtonSkeletonProps) => {
  const computedWidth = getWidth({ size, fullWidth, width });
  const computedHeight = getHeight({ size, height });

  return (
    <Skeleton
      variant={circular ? 'circular' : 'rounded'}
      width={computedWidth}
      height={computedHeight}
      className={className}
    />
  );
};
export default ButtonSkeleton;
